import { HttpHandler } from 'msw'

import { getAllRefills } from './getAllRefills'

export const refills: HttpHandler[] = [getAllRefills]
